module.exports = __webpack_public_path__ + "img/icon-plant-1.3b6d8350.svg";